"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typing = void 0;
exports.ethParamsToValues = ethParamsToValues;
exports.ethResolveBooleanArrayParameter = ethResolveBooleanArrayParameter;
exports.ethResolveBooleanParameter = ethResolveBooleanParameter;
exports.ethResolveParameter = ethResolveParameter;
exports.ethResolveStringArrayParameter = ethResolveStringArrayParameter;
exports.ethResolveStringParameter = ethResolveStringParameter;
exports.isBooleanArrayParameter = isBooleanArrayParameter;
exports.isBooleanParameter = isBooleanParameter;
exports.isIndexedParameter = isIndexedParameter;
exports.isStringArrayParameter = isStringArrayParameter;
exports.isStringParameter = isStringParameter;
exports.isTupleArrayParameter = isTupleArrayParameter;
exports.isTupleParameter = isTupleParameter;
exports.parameterToString = parameterToString;
exports.resolve = void 0;
exports.resolver = resolver;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _util = require("@blockwell/util");
var _class;
function isStringParameter(param) {
  let type = Typing.parse(param);
  return !type.array && type.name !== "bool" && type.name !== "tuple";
}
function isTupleParameter(param) {
  let type = Typing.parse(param);
  return !type.array && type.name === "tuple";
}
function isBooleanParameter(param) {
  let type = Typing.parse(param);
  return !type.array && type.name === "bool";
}
function isStringArrayParameter(param) {
  let type = Typing.parse(param);
  return type.array && type.name !== "bool" && type.name !== "tuple";
}
function isTupleArrayParameter(param) {
  let type = Typing.parse(param);
  return type.array && type.name === "tuple";
}
function isBooleanArrayParameter(param) {
  let type = Typing.parse(param);
  return type.array && type.name === "bool";
}
function isIndexedParameter(param) {
  return !!param.hash;
}
function parameterToString(param) {
  if (isTupleParameter(param)) {
    return param.components.map(it => parameterToString(it)).join(";");
  }
  if (isTupleArrayParameter(param)) {
    return param.values.map(it => parameterToString(it)).join(":");
  }
  if (isStringArrayParameter(param) || isBooleanArrayParameter(param)) {
    return param.values.map(it => it.toString()).join(";");
  }
  if (isIndexedParameter(param)) {
    return param.hash;
  }
  return param.value.toString();
}
class Typing {
  static from(info) {
    let typing = new Typing(info.name);
    Object.assign(typing, info);
    return typing;
  }
  static toString(info) {
    return info.name + (info.size || "") + (info.array ? "[" : "") + (info.length || "") + (info.array ? "]" : "");
  }
  static parse(input) {
    let type;
    if (typeof input === "string") {
      type = input;
    } else {
      type = input.type;
    }
    let match = /^([a-z]+)(\d*)(\[(\d*)])?$/.exec(type);
    let typing;
    if (match) {
      let name = match[1];
      let array;
      let size;
      let length;
      if (match[2]) {
        size = parseInt(match[2]);
      } else if (name === "uint" || name === "int") {
        size = 256;
      }

      // alias
      if (name === "byte") {
        name = "bytes";
        size = 1;
      }
      if (match[3]) {
        array = true;
      }
      if (match[4]) {
        length = parseInt(match[4]);
      }
      typing = new Typing(name, array, size, length);
    } else {
      typing = new Typing("any");
    }
    if (typeof input !== "string") {
      if (input.name) {
        typing.parameterName = input.name;
      }
      if (input.components) {
        typing.components = input.components.map(it => Typing.parse(it));
      }
      if (input.indexed) {
        typing.indexed = true;
      }
      if ("internalType" in input) {
        typing.internalType = input.internalType;
      }
    }
    return Object.freeze(typing);
  }
  constructor(name, array = false, size, length) {
    this.name = name;
    if (array) {
      this.array = array;
    }
    if (size) {
      this.size = size;
    }
    if (length) {
      this.length = length;
    }
  }
  equals(other) {
    if (this.name !== other.name || this.array !== other.array || this.length !== other.length || this.size !== other.size || this.indexed !== other.indexed) {
      return false;
    }
    if (this.components) {
      if (!other.components) {
        return false;
      }
      if (this.components.length !== other.components.length) {
        return false;
      }
      for (let i = 0; i < this.components.length; i++) {
        if (!this.components[i].equals(other.components[i])) {
          return false;
        }
      }
    } else if (other.components) {
      return false;
    }
    return true;
  }
  arrayElement() {
    let element = new Typing(this.name, false, this.size);
    element.components = this.components;
    return element;
  }
  isPrimitiveArray() {
    return this.array && (this.name === "string" || this.name === "address" || this.name === "uint" || this.name === "int" || this.name === "bytes" || this.name === "bool");
  }
  toString() {
    return Typing.toString(this);
  }
  toJSON() {
    return this.toString();
  }
  toTypeInfo() {
    let info = {
      ...this
    };
    if (this.components) {
      info.components = this.components.map(it => it.toTypeInfo());
    }
    return info;
  }
}
exports.Typing = Typing;
_class = Typing;
(0, _defineProperty2.default)(Typing, "uint", _class.parse("uint"));
(0, _defineProperty2.default)(Typing, "address", _class.parse("address"));
(0, _defineProperty2.default)(Typing, "bool", _class.parse("bool"));
(0, _defineProperty2.default)(Typing, "string", _class.parse("string"));
(0, _defineProperty2.default)(Typing, "any", _class.parse("any"));
function ethParamsToValues(params) {
  return params.map(it => {
    if (isStringArrayParameter(it) || isBooleanArrayParameter(it)) {
      return it.values;
    }
    if (isStringParameter(it) || isBooleanParameter(it)) {
      return it.value;
    }
    if (isTupleArrayParameter(it)) {
      return ethParamsToValues(it.values);
    }
    if (isTupleParameter(it)) {
      return ethParamsToValues(it.components);
    }
    return it.hash;
  });
}
function ethResolveParameter(params, path) {
  if (!params) {
    return null;
  }
  let parts = path.split(".");
  let list = params;
  let part = parts.shift();
  while (part) {
    let num = parseInt(part);
    let param;
    if (isNaN(num)) {
      param = list.find(it => it.name === part);
    } else {
      param = list[num];
    }
    if (!param) {
      return null;
    }
    part = parts.shift();
    if (!part) {
      return ethParamsToValues([param])[0];
    } else {
      if (isBooleanArrayParameter(param) || isStringArrayParameter(param)) {
        let num = parseInt(part);
        if (isNaN(num)) {
          return null;
        } else {
          return param.values[num];
        }
      } else if (isTupleParameter(param)) {
        list = param.components;
      } else if (isTupleArrayParameter(param)) {
        list = param.values;
      } else {
        return null;
      }
    }
  }
}
function ethResolveStringParameter(params, path) {
  let resolved = ethResolveParameter(params, path);
  if (typeof resolved === "string") {
    return resolved;
  }
  return null;
}
function ethResolveStringArrayParameter(params, path) {
  let resolved = ethResolveParameter(params, path);
  if ((0, _util.isStrings)(resolved)) {
    return resolved;
  }
  return null;
}
function ethResolveBooleanParameter(params, path) {
  let resolved = ethResolveParameter(params, path);
  if (typeof resolved === "boolean") {
    return resolved;
  }
  return null;
}
function ethResolveBooleanArrayParameter(params, path) {
  let resolved = ethResolveParameter(params, path);
  if ((0, _util.isBooleans)(resolved)) {
    return resolved;
  }
  return null;
}
const resolve = exports.resolve = {
  string: ethResolveStringParameter,
  stringArray: ethResolveStringArrayParameter,
  bool: ethResolveBooleanParameter,
  boolArray: ethResolveBooleanArrayParameter
};
function resolver(params) {
  return {
    string: path => ethResolveStringParameter(params, path),
    stringArray: path => ethResolveStringArrayParameter(params, path),
    bool: path => ethResolveBooleanParameter(params, path),
    boolArray: path => ethResolveBooleanArrayParameter(params, path)
  };
}
//# sourceMappingURL=Typing.js.map